import type { RentalType } from "@/components/checkout/CheckoutRentalTypeEditor";

export function isDeliveryAllowedForCheckout(
  rentalType: RentalType,
  carInfo: { selfDriveDeliveryEnabled?: boolean; deliveryEnabled?: boolean } | null | undefined,
): boolean {
  // Hourly services require their selected meeting/event location. Never
  // strip it during the widget-to-checkout handoff because an aggregate
  // legacy flag is off. Self-drive alone depends on its dedicated switch.
  if (rentalType !== "driving") return true;
  return carInfo?.selfDriveDeliveryEnabled === true;
}